export interface HttpsLinkProps {
  value: string;
}

/**
 * Renders a validated https URL value as a safe external link.
 *
 * Callers must gate rendering behind `isHttpsUrl(value)` (see
 * `@/sections/poe/utils/httpsUrl`) so only https:// values reach this anchor.
 */
export const HttpsLink = ({ value }: HttpsLinkProps) => {
  const url = value.trim();
  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      className="text-chariot-brand-primary break-all hover:underline"
      // Anchors inside shared Table cells must stop propagation: ancestor
      // row/label handlers in TableBody.tsx call preventDefault on bubbled
      // clicks, which would cancel the anchor's default navigation (and the
      // click would also trigger the row's inspect behavior). Mirrors
      // ITSMTicketCell and TableCellContent's Link wrapper.
      onClick={e => e.stopPropagation()}
    >
      {url}
    </a>
  );
};
